export default "__VITE_ASSET__DjW$Bsas__"